export const getDefaultEventColors = (bgColor: string, color: string): { color: string; bgColor: string } => {
    if (!bgColor || !color) {
        return { bgColor: "#eaddff", color: "#21005e" }
    }

    return { bgColor, color }
}
